import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Spinner, Alert } from 'react-bootstrap';
import { format } from 'date-fns';
import ToPeso from './ToPeso';
import GLOBALVAR from '../../constants';
import './css/UpcomingDueDates.scss';

const UpcomingDueDates = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [upcomingDues, setUpcomingDues] = useState(null);

    useEffect(() => {
        const fetchUpcomingDues = async () => {
            try {
                const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-dues/upcoming`);
                setUpcomingDues(response.data);
                setError(null);
            } catch (err) {
                setError('Failed to load upcoming due dates');
                console.error('Error fetching upcoming dues:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchUpcomingDues();
    }, []);

    if (loading) {
        return (
            <div className="section-loading">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    if (!upcomingDues || upcomingDues.count === 0) {
        return <Alert variant="info">No upcoming due dates in the next 14 days.</Alert>;
    }

    return (
        <div className="upcoming-dues">
            <div className="section-header">
                <h2>
                    <i className="fa-solid fa-calendar-days"></i>
                    Upcoming Due Dates
                    <small>Next 14 Days ({format(new Date(upcomingDues.dateRange.from), 'MMM dd')} - {format(new Date(upcomingDues.dateRange.to), 'MMM dd, yyyy')})</small>
                </h2>
                <div className="summary-stats">
                    <div className="stat">
                        <span className="label">Total Due Amount:</span>
                        <span className="value"><ToPeso amount={upcomingDues.summary.totalDueAmount} /></span>
                    </div>
                    <div className="stat">
                        <span className="label">Total Penalties:</span>
                        <span className="value"><ToPeso amount={upcomingDues.summary.totalPenalties} /></span>
                    </div>
                    <div className="stat">
                        <span className="label">Total Payable:</span>
                        <span className="value"><ToPeso amount={upcomingDues.summary.totalPayable} /></span>
                    </div>
                </div>
            </div>

            <Table responsive hover className="dues-table">
                <thead>
                    <tr>
                        <th>Due Date</th>
                        <th>Borrower</th>
                        <th>Due Amount</th>
                        <th>Penalty</th>
                        <th>Total Payable</th>
                        <th>Days Until Due</th>
                        <th>Account Officer</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {upcomingDues.data.map((due) => (
                        <tr key={`${due.loanId}-${due.dueDate}`} className={due.daysUntilDue <= 3 ? 'urgent' : ''}>
                            <td>{format(new Date(due.dueDate), 'MMM dd, yyyy')}</td>
                            <td>
                                <a href={`/applicant/${due.borrower.id}`}>
                                    {due.borrower.fullName}
                                </a>
                            </td>
                            <td><ToPeso amount={due.dueAmount} /></td>
                            <td><ToPeso amount={due.penalty} /></td>
                            <td><ToPeso amount={due.totalPayable} /></td>
                            <td>
                                <span className={`days-badge ${due.daysUntilDue <= 3 ? 'urgent' : ''}`}>
                                    {due.daysUntilDue} days
                                </span>
                            </td>
                            <td>{due.accountOfficer}</td>
                            <td>
                                <a href={`/loans/${due.loanId}`} className="btn btn-sm btn-primary">
                                    <i className="fa-solid fa-eye"></i>
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default UpcomingDueDates;